import { createBaseSelectors, createFetchReducer } from '@nexio/ui-redux';
import _ from 'lodash';

import {
    WEBHOOKS_FAILURE,
    WEBHOOKS_LOAD,
    WEBHOOKS_SUCCESS,
    WEBHOOK_LOG_FAILURE,
    WEBHOOK_LOG_LOAD,
    WEBHOOK_LOG_SUCCESS,
    WEBHOOK_RESEND_FAILURE,
    WEBHOOK_RESEND_LOAD,
    WEBHOOK_RESEND_SUCCESS
} from './webhookLogActions';

export const webhooksReducer = createFetchReducer({
    loadActionType: WEBHOOKS_LOAD,
    failureActionType: WEBHOOKS_FAILURE,
    successActionType: WEBHOOKS_SUCCESS
});

export const webhookReducer = createFetchReducer({
    failureActionType: WEBHOOK_LOG_FAILURE,
    loadActionType: WEBHOOK_LOG_LOAD,
    successActionType: WEBHOOK_LOG_SUCCESS
});

export const webhookResendReducer = createFetchReducer({
    failureActionType: WEBHOOK_RESEND_FAILURE,
    loadActionType: WEBHOOK_RESEND_LOAD,
    successActionType: WEBHOOK_RESEND_SUCCESS
});

const webhooksBaseSelectors = createBaseSelectors('entities.webhooks');
const webhookBaseSelectors = createBaseSelectors('entities.webhook');
const webhookResendBaseSelectors = createBaseSelectors('entities.webhookResend');

export const getWebhooks = (state) => {
    let { rows = [] } = webhooksBaseSelectors.getData(state) || {};

    rows = _.map(rows, (row) => {
        if (!_.get(row, 'requestBody.eventType')) {
            const requestBody = _.get(row, 'requestBody');
            delete row.requestBody;
            _.set(row, 'requestBody.data', requestBody);
            _.set(row, 'requestBody.eventType', _.get(row, 'eventType'));
        }

        return row;
    });

    return rows;
};

export const getWebhookCount = (state) => {
    const { count = 0 } = webhooksBaseSelectors.getData(state) || {};

    return count;
};

export const getWebhookHasMore = (state) => {
    const { hasMore = false } = webhooksBaseSelectors.getData(state) || {};

    return hasMore;
};

export const getWebhookPages = (state) => {
    const { pages } = webhooksBaseSelectors.getData(state) || {};

    return pages;
};

export const getWebhookLog = (state) => {
    return webhookBaseSelectors.getData(state) || {};
};

export const getWebhookResend = (state) => {
    return webhookResendBaseSelectors.getData(state);
};

export const getIsWebhooksLoading = webhooksBaseSelectors.getIsLoading;
export const getWebhooksErrorMessage = webhooksBaseSelectors.getErrorMessage;

export const getIsWebhookLogLoading = webhookBaseSelectors.getIsLoading;
export const getWebhookLogErrorMessage = webhookBaseSelectors.getErrorMessage;

export const getIsWebhookResendLoading = webhookResendBaseSelectors.getIsLoading;
export const getWebhookResendErrorMessage = webhookResendBaseSelectors.getErrorMessage;
